import cc from 'store/util/createReduxConstant';

export const FETCH_SERVICE_RETAINER = cc('FETCH_SERVICE_RETAINER');
export const FETCH_SERVICE_RETAINER_SUCCESS = cc('FETCH_SERVICE_RETAINER_SUCCESS');
export const FETCH_SERVICE_RETAINER_FAIL = cc('FETCH_SERVICE_RETAINER_FAIL');
